export class Validite {

    
	public dateJusquau: string;

	public nbJours: number;

	public nbMois: number;

	constructor() {
        this.nbJours = 0;
        this.nbMois = 0;
	}
}
